

































































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
import PicModal from '@/components/upload/picModal.vue'
import EditorCustomize from '@/components/editorCustomize/index.vue'
@Component({
  components: {
    PicModal,
    EditorCustomize
  }
})
export default class MemberLevelSetting extends AbpBase {
  MemberLevelConfig = {
    Items: [
      {
        Name: null,
        Min: null,
        Max: null,
        Discount: null,
        MemberCardBackgroundImage: null,
        MemberBenefit: null
      }
    ]
  }

  ruleMemberLevelConfig1 = {
    Name: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
    Min: [{ required: true, validator: this.validateMin, trigger: 'blur' }],
    Max: [{ required: true, validator: this.validateMax, trigger: 'blur' }],
    Discount: [
      {
        required: true,
        validator: this.validateDiscount,
        trigger: 'blur'
      }
    ]
  }

  viewMemberBenefit: boolean = false
  editMemberBenefit: boolean = false
  nowEditIndex: number = 0

  memberBenefitCancel() {
    this.viewMemberBenefit = false
  }

  memberBenefitOk() {}

  validateMin(rule, value, callback) {
    if (value == null) {
      return callback(new Error('请输入成长值最小值'))
    }
    if (value < 0) {
      callback(new Error('成长值最小值不能小于0'))
    } else if (rule.max && value > rule.max) {
      callback(new Error('不能大于成长值最大值'))
    } else {
      callback()
    }
  }

  validateMax(rule, value, callback) {
    if (value == null) {
      return callback(new Error('请输入成长值最大值'))
    }
    if (value < 0) {
      callback(new Error('成长值最大值不能小于0'))
    } else if (rule.min && value < rule.min) {
      callback(new Error('不能小于成长值最小值'))
    } else {
      callback()
    }
  }

  validateDiscount(rule, value, callback) {
    if (value == null || value == '') {
      return callback(new Error('请输入会员折扣'))
    }
    if (value <= 0) {
      return callback(new Error('会员折扣不能小于等于0'))
    } else if (value > 10) {
      return callback(new Error('会员折扣不能大于10'))
    } else {
      callback()
    }
  }

  ruleMemberLevelConfig2 = {
    MemberCardBackgroundImage: [
      { required: true, message: '请选择会员卡背景图', trigger: 'blur,change' }
    ],
    MemberBenefit: [
      { required: true, message: '请输入会员权益', trigger: 'blur' }
    ]
  }

  created() {
    this.getConfig('MemberLevelConfig')
  }

  /**
   * 获取设置
   */
  getConfig(key) {
    MallConfig.getMallConfig(key).then(res => {
      if (res.data && res.data.Items && res.data.Items.length > 0) {
        this[key] = res.data
      }
    })
  }

  /**
   * 保存
   */
  submit() {
    let vm = this
    let isvalid = true
    vm.MemberLevelConfig.Items.forEach((item, index) => {
      let levelForma: any = vm.$refs['levelForma' + index]
      let levelFormb: any = vm.$refs['levelFormb' + index]
      levelForma[0].validate(valid => {
        if (!valid) {
          isvalid = false
        }
      })
      levelFormb[0].validate(valid => {
        if (!valid) {
          isvalid = false
        }
      })
    })
    if (isvalid) {
      MallConfig.updateMallConfig(
        'MemberLevelConfig',
        '会员等级配置',
        vm.MemberLevelConfig
      ).then(res => {
        vm.$Notice.success({
          desc: '提交成功'
        })
        vm.getConfig('MemberLevelConfig')
      })
    }
  }

  /**
   * 添加等级
   */
  addLevelFn() {
    let obj = {
      Name: null,
      Min: null,
      Max: null,
      Discount: null,
      MemberCardBackgroundImage: null,
      MemberBenefit: null
    }

    this.MemberLevelConfig.Items.push(obj)
  }

  /**
   * 编辑器改变
   */
  editorChange(e) {
    this.MemberLevelConfig.Items[this.nowEditIndex].MemberBenefit = e
  }

  /**
   * 删除等级
   */
  deleteLevelFn(index) {
    this.$Modal.confirm({
      title: '提示',
      content: `确定要删除吗?`,
      onOk: () => {
        this.MemberLevelConfig.Items.splice(index, 1)
      }
    })
  }

  /**
   * 选择背景图
   */
  picChange(e, index) {
    this.MemberLevelConfig.Items[index].MemberCardBackgroundImage = e[0].url
  }
}
